import * as z from "zod";
import { mutator } from "./mutator";

export const publishConnectorSchema = z.object({
  connectedAppId: z.string(),
});

export const publishConnectedApp = mutator({
  schema: publishConnectorSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app } }) => {
    await tx.mutate.connectedApps.update({
      id: app.id,
      fresh: false,
    });
  },
});
